import strftime from 'strftime';

export function formatDate(date) {
  const utc = strftime.utc();
  return utc('%a, %b. %e, %Y', new Date(date));
}

export const addDays = (date, days) => {
  const copy = new Date(date);
  copy.setDate(copy.getDate() + days);
  return copy;
};

export const shortenWeekDay = dateString => {
  const weekDayNames = {
    Sunday: 'Sun',
    Monday: 'Mon',
    Tuesday: 'Tue',
    Wednesday: 'Wed',
    Thursday: 'Thu',
    Friday: 'Fri',
    Saturday: 'Sat'
  };

  if (dateString) {
    let day = dateString.split(',')[0];
    day = weekDayNames[day] ? weekDayNames[day] : day;
    return day.concat(', ', dateString.split(',')[1]);
  }
};

const dateToYYYYMMDD = dateStr => {
  const dateParts =
    dateStr?.match(/(\w+),\s*(\w+)\.\s*(\d+),\s*(\d{4})/) ||
    dateStr?.match(/(\w+),\s*(\w+)\s*(\d+),\s*(\d{4})/);
  if (dateParts) {
    const date = new Date(`${dateParts[2]} ${dateParts[3]}, ${dateParts[4]}`);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based in JavaScript
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }
};

export const isDateMoreThanTwoWeeksAway = dateStr => {
  const formattedDeliveryDate = dateToYYYYMMDD(dateStr); // already in YYYY-MM-DD format
  const today = new Date().toISOString().split('T')[0]; // YYYY-MM-DD format

  if (formattedDeliveryDate) {
    const todayDate = new Date(today);
    const deliveryDate = new Date(formattedDeliveryDate);

    const differenceInTime = deliveryDate.getTime() - todayDate.getTime();
    const differenceInDays = differenceInTime / (1000 * 3600 * 24);
    return Math.round(differenceInDays) > 14; // TODO - pass in a var number of days
  }
  return true;
};
